import Vue from 'vue'
import Vuex from 'vuex'

/*
  업무용 로컬 스토어 샘플
    - getName 함수 필수 구현
    - createInstance 함수 필수 구현
*/

/*
  return
   - vue intance를 식별하기 위한 unique id
*/
const getName = () => {
  return 'loading'
}

/*
   return
    - localstore 저장용 vue instance
*/
const createInstance = () => {
  let localStore = ''

  if (window.vue.getStore(getName) === undefined) {
    const store = new Vuex.Store({
      state: {
        instance: undefined,
        loadingCnt: 0
      },
      mutations: {
        SET_INSTANCE (state, instance = undefined) {
          Vue.set(state, 'instance', instance)
        },
        INCREMENT (state) {
          state.loadingCnt++
        },
        DECREMENT (state) {
          if (state.loadingCnt > 0) {
            state.loadingCnt--
          }
        }
      }
    })

    // local vuex 용 vue instance 추가
    localStore = new Vue({
      store: store
    })
  }

  return localStore
}

var store = {}
store.getName = getName
store.createInstance = createInstance

export default store



// WEBPACK FOOTER //
// ./src/config/vuex/loading.js